import {
  DeviceInterfaceType,
  instanceOfQaEquipmentCatalogDto,
  instanceOfQaEquipmentRtSystemDto,
  instanceOfUnicheckDeviceDto,
  instanceOfUnicheckSimulatorDto,
  MedicalSystemCatalogDto,
  MedicalSystemRtSystemDto,
  PtwQaEquipmentWithRegistrationDto,
  QaEquipmentCatalogDto,
  QaEquipmentRtSystemDto,
  UnicheckDeviceDto,
  UnicheckSimulatorDto,
} from '@/api/generator';

// Typeguard needs to be adjusted as soon as other PTWDevices are there
export function isIOTDevice(
  rtSystem:
    | MedicalSystemRtSystemDto
    | QaEquipmentRtSystemDto
    | MedicalSystemCatalogDto
    | QaEquipmentCatalogDto,
): rtSystem is UnicheckDeviceDto | UnicheckSimulatorDto | PtwQaEquipmentWithRegistrationDto {
  if (instanceOfQaEquipmentRtSystemDto(rtSystem) || instanceOfQaEquipmentCatalogDto(rtSystem)) {
    return (
      rtSystem.deviceInterfaceType === DeviceInterfaceType.PtwioT ||
      rtSystem.deviceInterfaceType === DeviceInterfaceType.PtwLegacyIot
    );
  } else {
    return false;
  }
}

/** A UNICHECK, either the real device or its simulator, by its type discriminator. */
export function isUnicheck(value: unknown): value is UnicheckDeviceDto | UnicheckSimulatorDto {
  return instanceOfUnicheckDeviceDto(value) || instanceOfUnicheckSimulatorDto(value);
}

export function isSimulator(qaEquipment: QaEquipmentRtSystemDto | QaEquipmentCatalogDto) {
  return qaEquipment.typeNumber?.endsWith('.SIMU');
}

export function isIotDeviceWithoutLicense(
  qaEquipment: QaEquipmentRtSystemDto,
  allDeviceLicensesMasterDeviceIds: string[],
): boolean {
  // Deliberately not isSimulator() above: that one tests typeNumber for '.SIMU'.
  if (
    !isIOTDevice(qaEquipment) ||
    qaEquipment.subModel === 'Simulator' ||
    // Licensing is currently only relevant for UNICHECK
    !instanceOfUnicheckDeviceDto(qaEquipment)
  ) {
    return false;
  }
  return (
    !!qaEquipment.masterDeviceId &&
    !allDeviceLicensesMasterDeviceIds.includes(qaEquipment.masterDeviceId)
  );
}
